import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isReadingPanePositionOff, isReadingPanePositionBottom } from './readingPanePosition';

/**
 * Returns a flag indicating whether the list view should show items in a single line.
 * Currently this is used when the reading pane setting is hidden or off client side, but
 * the actual persisted setting is not RIGHT. If the actual setting is RIGHT and the client
 * side setting is OFF it means that we have overridden the RIGHT setting in which case we
 * still want to show list view items in 3 line and not single line
 */
export function isSingleLineListView(): boolean {
    return (
        (isReadingPanePositionBottom() || isReadingPanePositionOff()) &&
        getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !=
            ReadingPanePosition.Right
    );
}
